// Franse teksten van de to-do's op het bord (zie todo.nl.ts).
export const todoFr = {
    title: 'À faire',
    from: 'de {name}',
    all: 'Toutes les choses à faire ({count})',
    sheetTitle: 'À faire pour {name}',
    due: 'au plus tard le {date}',
    empty: 'Plus rien à faire',
    done: 'Fait',
    everyone: 'Tous',
    filterOpen: 'À faire',
    filterDone: 'Fait',
    filterAll: 'Tout',
    doneSection: 'Fait ({n})',
    doneBy: '{name} · {when}',
    forWho: 'pour {name}',
    created: 'ajouté le {date}',
    important: 'Important',
    add: 'Ajouter une chose à faire',
    noDescription: 'Pas de détails',
    emptyDone: 'Rien de fait cette semaine',
    assign: 'Attribuer à…',
    assignTitle: 'Attribuer à',
    assignSave: 'Attribuer',
    assigned: 'Attribué',
    assignFailed: 'Attribution impossible',
};
//# sourceMappingURL=todo.fr.js.map